export default __webpack_public_path__ + "static/media/strider.b045b7fb.svg";